import { useEffect, useRef, type RefObject } from 'react'

export function useOutsideMouseDown(
  enabled: boolean,
  onOutside: () => void,
  primaryRef: RefObject<HTMLElement | null>,
  secondaryRef?: RefObject<HTMLElement | null>,
  tertiaryRef?: RefObject<HTMLElement | null>
) {
  const onOutsideRef = useRef(onOutside)

  useEffect(() => {
    onOutsideRef.current = onOutside
  }, [onOutside])

  useEffect(() => {
    if (!enabled) return

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        primaryRef.current?.contains(target) ||
        secondaryRef?.current?.contains(target) ||
        tertiaryRef?.current?.contains(target)
      )
        return
      onOutsideRef.current()
    }

    document.addEventListener('mousedown', handleMouseDown)
    return () => document.removeEventListener('mousedown', handleMouseDown)
  }, [enabled, primaryRef, secondaryRef, tertiaryRef])
}
